import {useSelector} from 'react-redux';
import {selectCompanies} from '../../store/companies';
import WalletSelect from './WalletSelect/WalletSelect';
import ProjectLabel from './ProjectLabel';

const ProjectSelect = ({projects, value, onChange, placeholder = '— none —', isClearable = true}) => {
    const companies = useSelector(selectCompanies);

    const options = projects.map(p => ({
        value: p.id,
        project: p,
        company: companies.find(c => c.id === p.companyId) ?? null,
    }));
    const selected = options.find(o => String(o.value) === String(value)) ?? null;

    return (
        <WalletSelect
            options={options}
            value={selected}
            onChange={opt => onChange(opt ? String(opt.value) : '')}
            placeholder={placeholder}
            isClearable={isClearable}
            formatOptionLabel={opt => <ProjectLabel project={opt.project} company={opt.company}/>}
        />
    );
};

export default ProjectSelect;